var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7929 2.79288C17.3783 2.20751 18.1722 1.87866 19 1.87866C19.8278 1.87866 20.6217 2.20751 21.2071 2.79288C21.7925 3.37824 22.1213 4.17216 22.1213 4.99998C22.1213 5.82781 21.7925 6.62173 21.2071 7.20709L19.7106 8.70362C19.7094 8.70478 19.7083 8.70595 19.7071 8.70711C19.7059 8.70827 19.7048 8.70943 19.7036 8.71058L12.7071 15.7071C12.5196 15.8946 12.2652 16 12 16H9C8.44772 16 8 15.5523 8 15V12C8 11.7348 8.10536 11.4804 8.29289 11.2929L16.7929 2.79288ZM16 6.4142L10 12.4142V14H11.5858L17.5858 7.99999L16 6.4142ZM19 6.58578L17.4142 4.99999L18.2071 4.20709C18.4174 3.9968 18.7026 3.87866 19 3.87866C19.2974 3.87866 19.5826 3.9968 19.7929 4.20709C20.0032 4.41738 20.1213 4.70259 20.1213 4.99998C20.1213 5.29737 20.0032 5.58259 19.7929 5.79288L19 6.58578ZM3.87868 6.87868C4.44129 6.31607 5.20435 6 6 6H9C9.55228 6 10 6.44772 10 7C10 7.55228 9.55228 8 9 8H6C5.73478 8 5.48043 8.10536 5.29289 8.29289C5.10536 8.48043 5 8.73478 5 9V18C5 18.2652 5.10536 18.5196 5.29289 18.7071C5.48043 18.8946 5.73478 19 6 19H15C15.2652 19 15.5196 18.8946 15.7071 18.7071C15.8946 18.5196 16 18.2652 16 18V15C16 14.4477 16.4477 14 17 14C17.5523 14 18 14.4477 18 15V18C18 18.7957 17.6839 19.5587 17.1213 20.1213C16.5587 20.6839 15.7957 21 15 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7957 3 18V9C3 8.20435 3.31607 7.44129 3.87868 6.87868Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.360a9e353885d1fd852272b249d26d47.svg";
export { ForwardRef as ReactComponent };